import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import ThreadItem from './ThreadItem';

const ThreadList = ({ threads, selected, onSelect }) => (
  <div className="ui segment scrollContent">
    <div className="scroll">
      <div className="list">
        {threads.map(t => (
          <ThreadItem
            key={t.recipient.id}
            thread={t}
            selected={selected}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  </div>
);

ThreadList.propTypes = {
  threads: PropTypes.array.isRequired,
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default pure(ThreadList);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ThreadList.js